/*
 * 検索フォームの送信クエリ変換
 *
 * 表示用 input(ユーザーが入力・閲覧する input[type="search"]) と、
 * 送信用 hidden input([data-tgtp-search-q], name="q") を分離する。
 *
 * submit 時に、表示用 input のキーワードを
 *   {keyword} OR title:{keyword} OR vendor:{keyword} OR body:{keyword}
 * へ変換して送信用 hidden(q) にセットする。
 * 先頭に素のキーワードを含めることで、フィールド指定(title/vendor/body)で
 * 検索対象を狭めすぎず、Shopify 標準検索の自然なマッチも活かす。
 * 表示用 input の値(キーワード)はそのまま残すため、UI に検索構文は表示されない。
 *
 * ※ URL エンコードは通常のフォーム送信に委ねる。
 * ※ document への delegation で 1 度だけバインドする(スクリプトが複数回読み込まれても二重登録しない)。
 */
(function () {
  if (window.__tgtpSearchQueryBound) return;
  window.__tgtpSearchQueryBound = true;

  var FIELDS = ['title', 'vendor', 'body'];

  function buildQuery(keyword) {
    // 先頭に素のキーワード、続けて各フィールド指定を OR で連結する
    var terms = [keyword];
    FIELDS.forEach(function (field) {
      terms.push(field + ':' + keyword);
    });
    return terms.join(' OR ');
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || typeof form.matches !== 'function' || !form.matches('[data-tgtp-search-form]')) {
      return;
    }

    // predictive-search 等が既に preventDefault 済み(空 or 候補選択)の場合は何もしない
    if (event.defaultPrevented) return;

    var visibleInput = form.querySelector('input[type="search"]');
    var hiddenQ = form.querySelector('[data-tgtp-search-q]');
    if (!visibleInput || !hiddenQ) return;

    var keyword = (visibleInput.value || '').trim();

    // 空文字は検索しない
    if (!keyword) {
      event.preventDefault();
      return;
    }

    // 表示用 input の値はキーワードのままにし、送信用 hidden(q) にのみ検索クエリを組み立てる
    hiddenQ.value = buildQuery(keyword);
  });
})();
